import { render, staticRenderFns } from "./eg_virtual_popover.vue?vue&type=template&id=13d3ca5a&scoped=true&"
import script from "./eg_virtual_popover.vue?vue&type=script&lang=js&"
export * from "./eg_virtual_popover.vue?vue&type=script&lang=js&"
import style0 from "./eg_virtual_popover.vue?vue&type=style&index=0&id=13d3ca5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3ca5a",
  null
  
)

export default component.exports